<script lang="ts" setup>
import { computed, type HTMLAttributes } from "vue";
import type { StepperSeparatorProps } from "reka-ui";
import { StepperSeparator, useForwardProps } from "reka-ui";
import { twMerge } from "tailwind-merge";

const props = defineProps<StepperSeparatorProps & { class?: HTMLAttributes["class"] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwarded = useForwardProps(delegatedProps);
</script>

<template>
  <StepperSeparator
    v-bind="forwarded"
    :class="
      twMerge(
        'h-px w-full bg-muted group-data-[disabled]:bg-muted group-data-[state=completed]:bg-accent-foreground group-data-[disabled]:opacity-50',
        props.class,
      )
    "
  />
</template>
